module.exports = __webpack_public_path__ + "img/spod.b84f037e.svg";